import { toast } from 'react-toastify';
import AsnAPI, { HangtagApiZpl } from '../../../Api/asn';

const generatePoLineHangtagZPL = async (
  userId: string,
  lineId: string,
  numLabels: number,
) => {
  try {
    const response = (await AsnAPI.getPoLineLabelHangtagData(
      userId,
      lineId,
      numLabels > 0 ? numLabels : undefined,
    )) as HangtagApiZpl;
    if (!response) throw new Error('failed to get the poLine data');

    return {
      zpl: response.zpl,
      request_id: response.request_id,
    };
  } catch (error: unknown) {
    console.error('Failed to get the purchase order line data', error);
    toast('Failed to get the purchase order line data', {
      type: 'error',
    });
    return null;
  }
};

const generatePoHangtagZPL = async (
  userId: string,
  internalId: string,
  numLabels: number,
) => {
  try {
    const response = (await AsnAPI.getPoLabelHangtagData(
      userId,
      internalId,
      numLabels,
    )) as HangtagApiZpl[];
    if (!response) throw new Error('failed to get the po data');

    return response;
  } catch (error: unknown) {
    console.error('Failed to get the purchase order line data', error);
    toast('Failed to get the purchase order line data', {
      type: 'error',
    });
    return null;
  }
};

export { generatePoLineHangtagZPL, generatePoHangtagZPL };
